import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> =>
{
    const authService = inject(AuthService);
    const platformId = inject(PLATFORM_ID);
    const isBrowser = isPlatformBrowser(platformId);

    // Skip authenticated requests on server to manage workload and avoid 401s
    if (!isBrowser) {
        const protectedPaths = ['bookings', 'dashboard', 'profile', 'tutor/profile', 'tutor/status'];
        const isProtected = protectedPaths.some(path => req.url.includes(path));
        
        if (isProtected) {
            return EMPTY;
        }
    }

    // Clone the request object
    let newReq = req.clone({
        url: environment.appURL + req.url
    });

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.
    if ( authService.getToken())
    {
        newReq = newReq.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + authService.getToken()),
        });
    }

    // Response
    return next(newReq).pipe(
        catchError((error) =>
        {
            // Catch "401 Unauthorized" responses
            if ( error instanceof HttpErrorResponse && error.status === 401 )
            {
                if (isBrowser) {
                    // Sign out
                    authService.signOut();

                    // Reload the app
                    // location.reload();
                } else {
                    // Silence errors in terminal during SSR
                    return EMPTY;
                }
            }

            return throwError(() => error);
        }),
    );
};